import axios from "axios";

export const getHomeData = async () => {
  try {
    const url = `${process.env.REACT_APP_HOME_PAGE_API}/frontend/home-page-content`;

    console.log("API URL:", url);
    console.log("Base URL:", process.env.REACT_APP_HOME_PAGE_API);

    const { data } = await axios.get(url);

    console.log("Response:", data);

    if (data?.success) {
      return data.data;
    }

    return {};
  } catch (error) {
    console.log("Error:", error);
    console.log("Error Response:", error.response);
    console.log("Error Message:", error.message);

    throw new Error(
      error?.response?.data?.message || "Failed to fetch home data"
    );
  }
};